module.exports = __webpack_public_path__ + "img/moped.1a5757a4.svg";